import { render, staticRenderFns } from "./EditFee.vue?vue&type=template&id=e4689d06&"
import script from "./EditFee.vue?vue&type=script&lang=js&"
export * from "./EditFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports